"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLogger = void 0;
/* eslint-disable no-console */
const log_level_1 = require("./log-level");
const LogLevelToConsoleMethod = {
    [log_level_1.LogLevel.DEBUG]: 'debug',
    [log_level_1.LogLevel.INFO]: 'info',
    [log_level_1.LogLevel.WARN]: 'warn',
    [log_level_1.LogLevel.ERROR]: 'error',
};
const DEFAULT_OPTIONS = {
    level: log_level_1.LogLevel.INFO,
    usePrefix: [],
};
/**
 * Logger implementation which prints log messages to browser console.
 *
 * TODO(roman):
 * - optional decorators: log level, calling method/class
 * - consider masking sensitive data within prints (wallet address etc). A la - https://raw.githubusercontent.com/tahowallet/extension/main/background/lib/logger.ts
 * -    the above will require stringifing all log args, as objects printed to log might have sensitive information.
 * - consider enabling setLevel() at runtime. This will result a need to persist the level for fluent DX cross page navigation.
 * - delegate for farther processing of log prints (for example - sending errors to remote server).
 */
class DefaultLogger {
    level;
    prefix;
    constructor(options) {
        const ops = { ...DEFAULT_OPTIONS, ...options };
        this.level = ops.level;
        this.prefix = typeof ops.usePrefix === 'string' ? [ops.usePrefix] : ops.usePrefix;
    }
    isDebugEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.DEBUG);
    }
    debug(message, ...args) {
        this.maybeCallConsole(log_level_1.LogLevel.DEBUG, message, args);
    }
    isInfoEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.INFO);
    }
    info(message, ...args) {
        this.maybeCallConsole(log_level_1.LogLevel.INFO, message, args);
    }
    isWarnEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.WARN);
    }
    warn(message, ...args) {
        this.maybeCallConsole(log_level_1.LogLevel.WARN, message, args);
    }
    isErrorEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.ERROR);
    }
    error(message, ...args) {
        this.maybeCallConsole(log_level_1.LogLevel.ERROR, message, args);
    }
    isLevelEnabled(testedLevel) {
        return testedLevel >= this.level;
    }
    child(tag) {
        return new DefaultLogger({ level: this.level, usePrefix: [...this.prefix, tag] });
    }
    maybeCallConsole(level, message, extraArgs) {
        if (!this.isLevelEnabled(level)) {
            return;
        }
        console[LogLevelToConsoleMethod[level]](...this.prefix, message, ...extraArgs);
    }
}
exports.DefaultLogger = DefaultLogger;
//# sourceMappingURL=data:application/json;base64,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